import _ from 'lodash'

import { MydAPI } from '_services/default'
import { deserializeGeneric } from 'utils/relationships'
import {
  FETCHING_EDUCATION_LEVELS,
  FETCHED_EDUCATION_LEVELS,
} from '_reducers/education_levels'


export const fetchEducationLevels = () => (
  dispatch => new Promise((resolve, reject) => {
    dispatch({
      type: FETCHING_EDUCATION_LEVELS,
    })

    MydAPI.get('/education-levels').then(
      response => {
        let educationLevels = _.map(response.data.data, item => deserializeGeneric(item))

        dispatch({
          type: FETCHED_EDUCATION_LEVELS,
          educationLevels,
        })
        resolve(educationLevels)
      }).catch(err => {
        dispatch({
          type: FETCHED_EDUCATION_LEVELS,
          educationLevels: [],
        })
        reject(err)
      })
  })
)
